var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form"},[_c('steps',{attrs:{"active":_vm.active,"isUpload":_vm.isUpload,"emsNeeded":_vm.matterInfo.emsNeeded}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"title"},[_vm._v("注释\n            "),_c('span',{staticClass:"text-danger"},[_vm._v("\n                    应湖北省公安厅内保总队要求，该事项仅在电脑端进行申报！尽情谅解！！！\n                ")])])
}]

export { render, staticRenderFns }